/**
 * Initializes the collection carousel.
 * This function sets up the carousel by selecting the necessary elements,
 * updating the buttons visibility, and adding event listeners for scrolling.
 */
export function initializeCarousel() {
  const prevButton = document.querySelector(".collection-carousel__button--prev");
  const nextButton = document.querySelector(".collection-carousel__button--next");
  const cardsWrapper = document.querySelector(".collection-carousel__cards-wrapper");
  const cardsContainer = document.querySelector(".collection-carousel__cards");
  const scrollAmount = 232 + 24; // width of card + gap
  const collectionCarousel = document.querySelector(".collection-carousel .collection-carousel__container");
  const collectionCarouselContainer = document.querySelector(".collection-carousel");

  if (window.getComputedStyle(collectionCarouselContainer).display !== 'none' && collectionCarousel.childElementCount > 0) {
    document.querySelector('.page-header .container .pagetitle').style.display = 'none';
    document.querySelector('.page-header').style.marginTop = '0';
    document.querySelector('.main-collection-section .utility-bar').style.borderTop = '1px solid #E2E2E2';
    document.querySelector('.main-collection-section .utility-bar').style.paddingTop = '20px';
  }

  // Check if arrows need to be displayed
  function updateButtonsVisibility() {
    const wrapperWidth = cardsWrapper.offsetWidth;
    const totalWidth = cardsContainer.scrollWidth;
    const scrollLeft = cardsWrapper.scrollLeft;

    if (totalWidth > wrapperWidth) {
      // At the beginning of the scroll
      if (scrollLeft === 0) {
        prevButton.style.display = 'none';
      } else {
        prevButton.style.display = 'block';
      }

      // At the end of the scroll
      if (scrollLeft + wrapperWidth >= totalWidth) {
        nextButton.style.display = 'none';
      } else {
        nextButton.style.display = 'block';
      }
    } else {
      nextButton.style.display = 'none';
      prevButton.style.display = 'none';
    }
  }

  updateButtonsVisibility();
  window.addEventListener('resize', updateButtonsVisibility);
  cardsWrapper.addEventListener('scroll', updateButtonsVisibility);

  prevButton.addEventListener("click", () => {
    cardsWrapper.scrollBy({
      left: -scrollAmount,
      behavior: "smooth"
    });
  });

  nextButton.addEventListener("click", () => {
    cardsWrapper.scrollBy({
      left: scrollAmount,
      behavior: "smooth"
    });
  });
}
